module.exports = function extractSignature(signatureDto) {
    if(!signatureDto || !signatureDto.Id)
        return undefined;

    return {
        id: signatureDto.Id,
        name: signatureDto.Name
    };
};
